import React, { useEffect, useMemo, useState } from 'react';

const getTimerLevel = (seconds) => {
  if (seconds === null) return 'normal';
  if (seconds <= 3) return 'critical';
  if (seconds <= 10) return 'warning';
  return 'normal';
};

const getTimerStyle = (level) => {
  const levelStyle = {
    normal: { fontWeight: 700, fontSize: '15px', color: '#374151', letterSpacing: 'normal' },
    warning: { fontWeight: 800, fontSize: '18px', color: '#d97706', letterSpacing: 'normal' },
    critical: { fontWeight: 900, fontSize: '22px', color: '#dc2626', letterSpacing: '0.02em' },
  };

  return {
    ...levelStyle[level],
    transition: 'all 0.2s ease',
  };
};

const ResultReviewTimer = ({ reviewUntil, totalSeconds = 60 }) => {
  const endMs = useMemo(() => (
    reviewUntil ? new Date(reviewUntil).getTime() : null
  ), [reviewUntil]);
  const [remainingSeconds, setRemainingSeconds] = useState(null);

  useEffect(() => {
    if (!endMs) {
      setRemainingSeconds(null);
      return undefined;
    }

    const updateRemaining = () => {
      const remaining = Math.max((endMs - Date.now()) / 1000, 0);
      setRemainingSeconds(remaining);
      return remaining;
    };

    const initialRemaining = updateRemaining();
    if (initialRemaining <= 0) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      const remaining = updateRemaining();
      if (remaining <= 0) {
        clearInterval(intervalId);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [endMs]);

  if (!endMs || remainingSeconds === null) {
    return null;
  }

  const level = getTimerLevel(remainingSeconds);
  const timerStyle = getTimerStyle(level);
  const remainingRatio = Math.min(Math.max(remainingSeconds / totalSeconds, 0), 1);
  const isEnded = remainingSeconds <= 0;

  return (
    <div style={{ marginTop: '6px' }}>
      <div style={timerStyle}>
        {isEnded
          ? '再確認の受付は終了しました'
          : `再確認の受付中：あと ${remainingSeconds.toFixed(1)} 秒`}
      </div>
      <div
        style={{
          marginTop: '6px',
          width: '100%',
          height: '8px',
          borderRadius: '999px',
          backgroundColor: '#fde68a',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${remainingRatio * 100}%`,
            height: '100%',
            borderRadius: 'inherit',
            background:
              level === 'critical'
                ? '#dc2626'
                : level === 'warning'
                  ? '#f59e0b'
                  : '#16a34a',
            transition: 'width 0.2s linear, background-color 0.2s ease',
          }}
        />
      </div>
    </div>
  );
};

export default ResultReviewTimer;
